import baseAPI from './axiosApi'

const api={
    get:'/api-u/org/getTree',
    delete:'/api-u/org/',
    addorupdate:'/api-u/org'
}
//获取部门树
export function queryDepartmentTreeList () {
    return baseAPI.axiosData(api.get,'get')
}
//删除部门
export function removeDepartment (id) {
    return baseAPI.axiosData(api.delete+id,'delete')
}
//编辑部门
export function updateDepartment (parameter) {
    return baseAPI.axiosData(api.addorupdate,'put',parameter)
}
//添加部门
export function addDepartment (parameter) {
    return baseAPI.axiosData(api.addorupdate,'post',parameter)
}